<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        persistent-hint
        prepend-icon="event"
        readonly
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="internalDate"
      :min="min"
      :max="max"
      no-title
      @input="menu = false"
      @change="setDate"
    />
  </v-menu>
</template>

<script>
export default {
  props: ["date", "min", "max", "label"],

  data: () => ({
    menu: false
  }),

  created() {
    this.internalDate = this.date;
    this.dateFormatted = this.formatDate(this.date);
  },

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },

  methods: {
    setDate(val) {
      this.internalDate = val;
      this.dateFormatted = this.formatDate(val);
      this.$emit("set-date", val);
    },

    formatDate(date) {
      if (!date) {
        return null;
      }

      const [year, month, day] = date.split("-");

      return `${month}/${day}/${year}`;
    }
  }
};
</script>
